/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar-entry-space.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 11:32
 */

import React, {Fragment, useState} from 'react';
import {Link} from 'react-router-dom';
import {getImageServerSmallUrl} from "../../../actions/environment";
import {BoxedLink} from "../../navigation/buttons/nav-buttons";
import {AnimatedChevronIcon2} from "../../navigation/links/nav-headlines";
import SmoothScrollbar from "../../scrollbars/smooth-scrollbar";
import SpaceAccessIcon from "../../navigation/icons/space-access-icon";
import {MembershipIconShort} from "../../navigation/icons/membership-icon";
import {GroupIcon, StarsIcon} from "../../navigation/icons/nav-icons";

const SidebarEntryPeekSpace = ({peekspace, className, text = null, size = 'small'}) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    // any children but 'GALLERY' are rendered as submenu entries
    // const renderChildren = (user, space) => {
    const renderChildren = (peekspace) => {
        const children = peekspace.children
        .filter(child => child.type !== 'GALLERY')
        .map(child => {
            const target = `/${peekspace.username}/space/${child.id}`;
            return <li key={child.id} className="nav-item">
                <Link to={target} className="ml-2">{child.name}</Link>
                <SpaceAccessIcon bigger medium access={child.access}/>
                <MembershipIconShort membership={child.membership}/>
            </li>
        });
        return <div className="sidebar-submenu">
            <ul className="nav flex-column">{children}</ul>
        </div>;
    }

    const toggleShowSubMenu = (event) => {
        event.preventDefault()
        setShowSubMenu(!showSubMenu);
    }

    const childrenCount = peekspace => {
        let children = null;
        if (peekspace.children) {
            children = peekspace.children.filter(child => child.type !== 'GALLERY')
        }
        return children && children.length > 0;
    }

    const activespace = `/${peekspace.username}/space/${peekspace.id}`;
    const hasChildren = childrenCount(peekspace);
    const containerSize = size === 'bigger' ? 'sidebar-body-container-big' : 'sidebar-body-container-small';
    const imageSize = size === 'bigger' ? 'sidebar-image-big' : 'sidebar-image-small';

    return <div className='mb-1'>
        <BoxedLink to={activespace} className='sidebar-card-container text-dark shadow'>
            <div className={`sidebar-body-container ${containerSize}`}>
                <div className='sidebar-image-container'>
                    <img className={`sidebar-image ${imageSize}`} src={getImageServerSmallUrl(peekspace.url)}/>
                </div>
                <div className='pt-4 pl-3 overflow-y-hidden'>
                    <div className='sidebar-space-title'>
                        <span className='mr-1'>{peekspace.name}</span>
                        <SpaceAccessIcon access={peekspace.access}/>
                        <MembershipIconShort membership={peekspace.membership}/>
                    </div>
                    <div className='small mb-2'>{peekspace.city}</div>

                    {size === 'bigger' && <Fragment>
                        <div className='small clr-red'>Mitglieder Wertung</div>
                        <div><span className='mr-1'>200+</span><GroupIcon small/></div>
                        <div><StarsIcon small/><StarsIcon small/><StarsIcon small/></div>
                        <div className='mt-3'><span className='fw-bolder'>Angesagt</span></div>
                    </Fragment>}
                </div>
                <span className="image-box-category small">{peekspace.category}</span>

            </div>
            {hasChildren && <AnimatedChevronIcon2 onClick={toggleShowSubMenu} isOpen={showSubMenu}/>}
        </BoxedLink>

        {showSubMenu && hasChildren &&
            <SmoothScrollbar className="sidebar-submenu mt-2">
                {renderChildren(peekspace)}
            </SmoothScrollbar>}
    </div>
}

export default SidebarEntryPeekSpace;
